import React, { useEffect } from "react";
import styles from "./../components/css/HomePage.module.css";
import NavBar from "../components/NavBar";
import ScrollThrough from "../components/ScrollThrough";
import PhantomPay from '../components/PhantomPay';

import { ToastContainer, toast } from 'react-toastify';

import coin1 from "./../images/coin1.webp";
import coin2 from "./../images/coin2.webp";
import storage from './../images/storage.webp';
import shield from './../images/shield.webp';
import check from './../images/check.webp';
import roadmap_left from './../images/roadmap-left.webp';
import roadmap_right from './../images/roadmap-right.webp';
import unicorn from './../images/unicorn.webp';
import piechart from './../images/piechart.png';
import piechart2 from './../images/piechart2.png';
import CheckPayment from "../components/CheckPayment";
import MakePayment from "../components/MakePayment";
import ContractBalance from "../components/ContractBalance";
import stance from "./../images/stance.webp";
import alfred from './../images/alfred.webp';
import roy from './../images/roy.webp';

const HomePage = () => {

  const contractAddress = "4GX1hDmkpCaRDcNHdjMDeXP19FXh56xbZGRpsK5nmdyq";

  const stanceLinkedIn = "https://www.linkedin.com/in/areelu-olayide-4558011b9"
  const ceo = "https://www.linkedin.com/in/alfred-isfahani-281875396"
  const royLinkedIn = "https://www.linkedin.com/in/ojo-felix-b98992329?utm_source=share_via&utm_content=profile&utm_medium=member_ios"

  useEffect(() => {
    // claim airdrop button while the page loads
    return
  }, [])

  const handleCopy = () => {
    navigator.clipboard.writeText("4GX1hDmkpCaRDcNHdjMDeXP19FXh56xbZGRpsK5nmdyq")

    toast.success("Contract address copied")

  }




  return (
    <>
      <div className={`${styles.heroSectionContainer}`}>
        <ToastContainer />
        <NavBar className={`${styles.navbar}`} />
        <div className={`${styles['hero-section']} `}>
          <div className="">
            <h1 className={`${styles['hero-h1']}`}>
              Claim Your <br />
              Airdrop <br />
              Join Now
            </h1>
            <p className={`${styles['hero-text']}`}>
              The worker-class meme coin with gold-reserve backing Funny. Bold. Transparent. Built for the people.
            </p>
            <div className={`${styles['cta-container']} d-flex align-items-center`}>
              {/* <a href="https://phantom.app/ul/v1/transfer?recipient=YourWalletAddressHere&amount=0.1&label=Support%20Us&message=Thanks%20for%20your%20support!" className='btn btn-warning text-black fw-bold rounded-0 me-3'>BUY ON RAYDIUM</a> */}
              <MakePayment />
              <a href="https://t.me/pinkponygirlcoin1" className='btn btn-outline-warning rounded-0 text-white'>JOIN TELEGRAM</a>
            </div>
          </div>
          <div className="text-center">
            <img src={coin1} alt="coin1" width="50%" height={"auto"} className="spinner-3d" />
          </div>
        </div>

        <div className="mt-3 mb-3 primary-text ms-5 fs-1">
          <ContractBalance contractAddress={contractAddress} />
        </div>

        <p className={`${styles['mint-addy']}`} onClick={handleCopy}>Contract Address: <span className={styles.CopyToClipboard}>4GX1hDmkpCaRDcNHdjMDeXP19FXh56xbZGRpsK5nmdyq <i class='fa fa-copy'></i></span></p>
      </div>

      <ScrollThrough scrollType="inifite-scroll-left" />

      <section id="about-us">

        <div className={`${styles.aboutContainer}`}>
          <div >
            <p className="secondary-text heading-text">ABOUT US</p>
            <small className="fs-6 text-white">
              PPGC GOLD V2 It is not just another meme coin- it’s a movement for labor, workers, hustlers, and women empowerment. We launched on Solana for speed and near-zero fees, and we’re backing the culture with transparent reserves you can verify any time.<br /><br />

              <span className="secondary-text">Built on Solana:</span> fast, cheap, battle-tested. <br />
              <span className="secondary-text">Transparent reserves:</span> view reserve wallets on-chain. <br />
              <span className="secondary-text">Worker-class ethos:</span> community first, humor intact. <br />
            </small>
          </div>
          <div className="secondary-text text-center">
            <img src={coin2} alt="coin2" width={'60%'} height={'auto'} className="vertical-bounce" />
          </div>
        </div>



        <ScrollThrough scrollType="inifite-scroll-right" />
      </section>

      <section>
        <CheckPayment />
      </section>

      <section id="roadmap">
        <div className={`${styles.roadmap}`}>
          <NavBar className={`${styles.navbar}`} />

          <div className={`${styles.roadmaprow}`}>
            <h1 className="heading-text text-white">WHY GOLD?</h1>
            <div className="row mt-5">
              <div className="col-4 pe-5 ps-5">
                <img src={storage} width={'10%'} height={'auto'} className="mb-2" />
                <p className="primary-text fw-bold">Gold as a Foundation</p>
                <p className="text-white">
                  A portion of the treasury is allocated to PAX Gold (PAXG) and other blue-chip assets. It’s a psychological and symbolic “floor” that signals long-term intent
                </p>
              </div>
              <div className="col-4 pe-5 ps-5">
                <img src={shield} width={'10%'} height={'auto'} className="mb-2" />
                <p className="primary-text fw-bold">Investor Confidence</p>
                <p className="text-white">
                  Reserves don’t peg the token, but they do show we’re serious, disciplined, and here to build.
                </p>
              </div>
              <div className="col-4 pe-5 ps-5">
                <img src={check} width={'10%'} height={'auto'} className="mb-2" />
                <p className="text-white fw-bold text-shadow">Transparent</p>
                <p className="text-white">
                  Reserve wallet addresses are published and auditable on-chain in real time.
                </p>
              </div>
            </div>

            <div className="text-center mt-3">
              <h1 className="primary-text heading-2-text">HOW TO BUY $PPGC</h1>
              <div className="d-flex justify-content-center">
                <button className="btn btn-warning me-3">Create a Wallet</button>
                <button className="btn btn-warning me-3">Fund Your Wallet With  $SOL</button>
                <button className="btn btn-warning me-3">Connect to a DEX</button>
                <button className="btn btn-warning me-3">Add the Contract Address</button>
                <button className="btn btn-warning me-3">Swap & Hold</button>
              </div>
            </div>

            <p className={`text-white text-center fs-4 mt-3`} onClick={handleCopy}>Contract Address: <span className={styles.CopyToClipboard}>4GX1hDmkpCaRDcNHdjMDeXP19FXh56xbZGRpsK5nmdyq <i class='fa fa-copy'></i></span></p>

          </div>
          <ScrollThrough scrollType="inifite-scroll-left" />
        </div>
      </section>

      <section id="token-section">
        <div class={`${styles['token-container']}`}>

          <div className="row align-items-center p-5">
            <div className="col-6">
              <div className={`${styles.glassmorphism}`}>
                <h1 className="fw-bold text-white fs-5 text-center">RESERVE ALLOCATION VAULTS</h1>

                <p className="fw-bold secondary-text">BTC</p>
                <div className="d-flex align-items-center my-pe-7 ">
                  <progress className="progress-bar w-100" value="30" max="100"></progress> <span className="ms-3 text-white">30%</span>
                </div>

                <p className="fw-bold secondary-text mt-3">ETH</p>
                <div className="d-flex align-items-center my-pe-7 ">
                  <progress className="progress-bar w-100" value="20" max="100"></progress> <span className="ms-3 text-white">20%</span>
                </div>

                <p className="fw-bold secondary-text mt-3">SOL</p>
                <div className="d-flex align-items-center my-pe-7 ">
                  <progress className="progress-bar w-100" value="20" max="100"></progress> <span className="ms-3 text-white">20%</span>
                </div>

                <p className="fw-bold secondary-text mt-3">PAXG(GOLD)</p>
                <div className="d-flex align-items-center my-pe-7 ">
                  <progress className="progress-bar w-100" value="20" max="100"></progress> <span className="ms-3 text-white">20%</span>
                </div>

                <p className="fw-bold secondary-text mt-3">OPS</p>
                <div className="d-flex align-items-center my-pe-7 ">
                  <progress className="progress-bar w-100" value="10" max="100"></progress> <span className="ms-3 text-white">10%</span>
                </div>


              </div>
            </div>
            <div className="col-6 ">
              <h1 className="fw-bold fs-5 text-center text-white">TOKENOMICS</h1>

              <img className="mt-4" src={piechart} width={'100%'} height={'100%'} />

              <div>
                <h1 className="fw-bold fs-4 text-white mt-3 text-center">TRANSPARENCY</h1>
                {/* <p className="text-white"><span className="primary-text fw-bold">Contract:</span> gbqKX2qPCqdwjXZpMhxC3BMsPV2fwFQVJXvMKKbYbXK</p> */}
                <p className="text-white"><span className="primary-text fw-bold">Treasury & Reserve Wallets:</span> Adding address and Link</p>
                <p className="text-white"><span className="primary-text fw-bold">Dev Wallet Policy:</span> vesting schedule, no stealth mints, no hidden taxes.</p>
                <p className="text-white"><span className="primary-text fw-bold">Risks:</span> Crypto is volatile; reserves are not a redemption right.</p>
              </div>
            </div>
          </div>


        </div>
      </section>

      <ScrollThrough scrollType="inifite-scroll-right" />

      <section id="roadmap_">
        <div className={`${styles.roadmap} `}>
          <div className="p-3">
            <div className="row ">
              <div className="col-6 ">
                <img src={roadmap_left} width={'100%'} height={'auto'} />
              </div>
              <div className={"col-6"}>
                <div className={`${styles.roadmap_right} p-4`}>
                  <div className="row">
                    <div className="col-6">
                      <p className="fs-5 fw-bold text-white">ABOUT</p>
                      <small className="text-white">
                        PPGC GOLD V2 It is not just another meme coin- it’s a movement for labor, workers, hustlers, and women empowerment. It's the coin of the working class - transparently backed by gold reserves and build on Solana for speed and low fees.
                      </small>
                      <div className="d-flex justify-content-around align-items-center">
                        {/* <button className="btn btn-sm btn-warning fw-bold">BUY NOW</button> */}
                        <MakePayment />
                        <a href="https://t.me/pinkponygirlcoin1" className="btn btn-sm btn-outline-warning">JOIN TELEGRAM</a>
                      </div>
                    </div>
                    <div className="col-6">
                      <img src={unicorn} alt="ppgc-unicorn" width={'100%'} height={'auto'} />
                    </div>
                  </div>

                  <div className="row mt-4">
                    <p className="fs-5 fw-bold text-white">WHY GOLD?</p>
                    <div className="col-6">

                      <small className="text-white">
                        <span className="text-warning fw-bold">Gold as a Foundation</span> <br />
                        PACX Back sich reservies got scholly simbol fior value combiris, floor value.
                      </small><br />

                      <small className="text-white mt-3">
                        <span className="text-warning fw-bold">Transparency</span> <br />
                        Combinmes meme hype with 4% otome of history's trustnisted assets
                      </small>


                    </div>
                    <div className="col-6">
                      <small className="text-white">
                        <span className="text-warning fw-bold">Transparency</span> <br />
                        Our reserve wallet address will be published for all to verify on-chain at any time.
                      </small><br />

                      <small className="text-white mt-3">
                        <span className="text-warning fw-bold">Investor Confidence</span> <br />
                        Combines megre hype with one of his trusted assets.
                      </small>
                    </div>
                  </div>



                  <div className="row mt-4">
                    <p className="fs-5 fw-bold text-white text-center">ROADMAP</p>
                    <div className="row">

                      <div className="col-lg-6 col-12 col-12 mb-2">

                        <img src={piechart2} width={'100%'} height={'100%'} alt="piechart" />

                      </div>
                      <div className="col-lg-6 col-md-12 col-12">
                        <small className="text-white"><span className="fw-bold text-warning">PHASE 1</span> Presale + Gold Reserve Creation</small><br />
                        <small className="text-white"><span className="fw-bold text-warning">PHASE 2</span> Liquidity on Raydium + Early CEX Listings</small><br />
                        <small className="text-white"><span className="fw-bold text-warning">PHASE 3</span> Marketing Raids + Community Growth</small><br />
                        <small className="text-white"><span className="fw-bold text-warning">PHASE 4</span> Expansions into NFTs, Merch, Worker-Class Advocacy</small><br />
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>




          </div>
        </div>
      </section>

      <ScrollThrough scrollType="inifite-scroll-right" />

      <section id='testimonial'>
        <div className={`${styles['token-container']} bg-black`}>
          <div className="p-5">
            <p className="text-center text-white fw-bold fs-5">Testimony from believers</p>

            <div className="row">
              <div className="col-4">
                <div className={` ${styles['testimonial-container']} card w-100 h-100 p-3`}>
                  <p>
                    <i className="fa fa-quote-left fa-2x text-white"></i>
                  </p>
                  <p className="text-white">
                    I believe in worker-class empowerment. PPGC is something different."
                  </p>
                  <span className="mt-3 primary-text">
                    -Early Supporter
                  </span>
                </div>
              </div>
              <div className="col-4">
                <div className={` ${styles['testimonial-container']} card col-4 w-100 h-100 p-3`}>
                  <p>
                    <i className="fa fa-quote-left fa-2x text-white"></i>
                  </p>
                  <p className="text-white">
                    Pink Pony Girl Coin is the funniest + realest meme coin I’ve seen."
                  </p>
                  <span className="mt-3 primary-text">
                    -ROY
                  </span>
                </div>
              </div>
              <div className="col-4">
                <div className={` ${styles['testimonial-container']} card col-4 h-100 w-100 p-3`}>
                  <p>
                    <i className="fa fa-quote-left fa-2x text-white"></i>
                  </p>
                  <p className="text-white">
                    I have spoken with the Dev team one to one. I have been a friend and a worker with him! And if a dev is dedicated to making changes then every project is a move to change. Be part of $PPGC it is an amazing project!"
                  </p>
                  <span className="mt-3 primary-text">
                    -Stance
                  </span>
                </div>

              </div>






            </div>


          </div>
        </div>
      </section>

      <ScrollThrough scrollType="inifite-scroll-left" />

      <section id='testimonial'>
        <div className={`${styles['token-container']} bg-black`}>
          <div className="p-5">
            <p className="text-center text-white fw-bold fs-5">Meet the team</p>

            <div className="row">
              <div className="col-4">
                <div className={` w-100 h-100 p-3 text-center`}>
                  <img src={alfred} width={'50%'} height={"auto"} />
                  <p className="text-white">
                    <span className="fw-bold">ALFRED ISFAHANI</span> <br/>
                    <span className={`${styles['text-justify']} primary-text`} >
                      <p>
                        Alfred Isfahani is the founder of PPGC GOLD and a long-time advocate for financial access for everyday workers. Based in Los Angeles, he built PPGC to combine community empowerment with a disciplined treasury model backed by gold and major digital assets.
                      </p>
                      <span className="text-white fw-bold">
                        CEO AND FOUNDER <span ><i className={`${styles.linkedInIcon} fa-brands fa-linkedin fa-2x`} onClick={() => { window.open(ceo, "_blank", "noopener,noreferrer") }}></i></span>
                      </span>
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-4">
                 <div className={` w-100 h-100 p-3 text-center`}>
                  <img src={stance} width={'50%'} height={"auto"} loading="lazy" />
                  <p className="text-white">
                    <span className="fw-bold">AREELU OLAYIDE (STANCE) </span> <br/>
                    <span className={`${styles['text-justify']} primary-text`} >
                      <p>
                        Areeolu Olayide (Stance) leads marketing and community growth for PPGC GOLD. He focuses on expanding the project’s visibility across social media while building a strong and engaged global community around the mission of worker empowerment.
                      </p>
                      <span className="text-white fw-bold">
                        CHIEF MARKETER <span ><i className={`${styles.linkedInIcon} fa-brands fa-linkedin fa-2x`} onClick={() => { window.open(stanceLinkedIn, "_blank", "noopener,noreferrer") }}></i></span>
                      </span>
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-4">
                 <div className={` w-100 h-100 p-3 text-center`}>
                  <img src={roy} width={'50%'} height={"auto"} />
                  <p className="text-white">
                    <span className="fw-bold">OJO FELIX (ROY) </span> <br/>
                    <span className={`${styles['text-justify']} primary-text`} >
                      <p>
                        Ojo Felix (Roy) manages community relations and engagement within the PPGC ecosystem. He works closely with members to support communication, organize discussions, and ensure a welcoming environment for new participants.
                      </p>
                     <span className="text-white fw-bold"> 
                      COMMUNITY MANAGER 
                      <span ><i className={`${styles.linkedInIcon} fa-brands fa-linkedin fa-2x`} onClick={() => { window.open(royLinkedIn, "_blank", "noopener,noreferrer") }}></i></span>
                      </span>
                    </span>
                  </p>
                </div>

              </div>






            </div>


          </div>
        </div>
      </section>

      <ScrollThrough scrollType="inifite-scroll-left" />

      <section id='faq'>
        <div className={`${styles.roadmap} p-5`}>
          <p className="text-center">
            <span className="primary-text fw-bold">FAQ </span><br />
            <span className="fs-5 text-white">We compiled a list of answers to address your most pressing questions regarding $PPGC </span>
          </p>


          <div>
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                    What is PPGC GOLD V2?
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    PPGC GOLD V2 is not just another meme coin- it’s a movement for labor, workers, hustlers, and women empowerment
                  </div>
                </div>
              </div>

              <div className="accordion-item mt-1">
                <h2 className="accordion-header" id="headingTwo">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    How is it backed by gold?
                  </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    We bought the $PAXG into the deployed wallet that will be trackable. This will bring stability and give you reason to hold be cause we going to be using the profit in the gold move to buyback into the project
                  </div>
                </div>
              </div>

              <div className="accordion-item mt-1">
                <h2 className="accordion-header" id="headingThree">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    How do I buy with Phantom?
                  </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    You either click buy button and buy directly or You open your phantom wallet and then paste the Contract address and swap
                  </div>
                </div>
              </div>

              <div className="accordion-item mt-1">
                <h2 className="accordion-header" id="headingFour">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    Will there be a presale?
                  </button>
                </h2>
                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Yes, The buy button is currently your chance to join the presale! <br/>

                    Click on the buy button, deposit some $SOL and secure a spot!
                  </div>
                </div>
              </div>

              <div className="accordion-item mt-1">
                <h2 className="accordion-header" id="headingFive">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    Is liquidity locked?
                  </button>
                </h2>
                <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Yes the liquidity is locked!
                  </div>
                </div>
              </div>

              <div className="accordion-item mt-1">
                <h2 className="accordion-header" id="headingSix">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    What chain is it on?
                  </button>
                </h2>
                <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Yes the liquidity is locked!
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>


      </section>

      <div className="text-center d-flex justify-content-center p-3">
        <p className="primary-text fw-bold fs-4">JOIN COMMUNITY</p>
        <p className="me-3 ms-3"><a href='https://x.com/ppgc1official?s=21'><i className="fab fa-x-twitter fa-3x text-black"></i></a></p>
        <p><a href="https://t.me/pinkponygirlcoin1"><i className="fab fa-telegram fa-3x"></i></a></p>
      </div>



    </>
  )
}

export default HomePage;